import { useQuery } from '@tanstack/react-query';
import { aiApplicationsClient } from '@terra/shared-rest-clients-ai-applications';
import {
  createApiHeaders,
  withOrchestratorClient,
} from '../../clients/tester-client/api-core';

export const AI_APPLICATION_URL_EDIT_RESTRICTION_KEY =
  'ai-application-url-edit-restriction';

const STALE_TIME_MS = 30_000;

export function useAiApplicationUrlEditRestriction({
  aiApplicationId,
  enabled = true,
}: {
  aiApplicationId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [AI_APPLICATION_URL_EDIT_RESTRICTION_KEY, aiApplicationId],
    queryFn: async () => {
      if (!aiApplicationId) {
        return {
          canEditUrl: true,
          componentsCount: 0,
          discoveryHasStarted: false,
        };
      }

      const response = await aiApplicationsClient.getUrlEditRestriction({
        params: { aiApplicationId },
        ...(await withOrchestratorClient(await createApiHeaders())),
      });

      if (response.status !== 200) {
        return {
          canEditUrl: true,
          componentsCount: 0,
          discoveryHasStarted: false,
        };
      }

      return response.body;
    },
    enabled: Boolean(aiApplicationId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    canEditUrl: query.data?.canEditUrl ?? true,
    urlEditRestrictionReason: query.data?.reason,
    isLoading: query.isLoading,
  };
}
